import types from './types'

export default {
  [types.RESET]: state => {
    state.statusResetPassword = void 0
    state.statusForgotPassword = void 0
  },
  [types.FORGOT_PASSWORD.REQUEST]: state => {
    state.statusForgotPassword = 'fetching'
  },
  [types.FORGOT_PASSWORD.SUCCESS]: (state) => {
    state.statusForgotPassword = 'success'
  },
  [types.FORGOT_PASSWORD.FAILURE]: state => {
    state.statusForgotPassword = 'failure'
  },
  [types.RESET_PASSWORD.REQUEST]: state => {
    state.statusResetPassword = 'fetching'
  },
  [types.RESET_PASSWORD.SUCCESS]: (state) => {
    state.statusResetPassword = 'success'
  },
  [types.RESET_PASSWORD.FAILURE]: state => {
    state.statusResetPassword = 'failure'
  }
}